module.exports = __webpack_public_path__ + "img/DSC_0067.5f702c5e.jpg";